import React, { useContext, useState } from "react"
import { Link } from "react-router-dom"
import { SmartDateFormat } from "../../util/dates"
import CommentSection from "../comments/CommentSection"
import { TextAsImage } from "./TextAsImage"
import { PostListItemExpandedStyles } from "./constants"
import { ShareUrlButton } from "../ShareUrlButton"
import { ReactionBlock } from "./ReactionBlock"
import RelatedPosts from "../RelatedPosts"
import clsx from "clsx"
import styles from "./styles.module.css"
import PremiereHeader from "./PremiereHeader"
import { PostListItemParams } from "../../types/posts"
import { UserContext } from "../HomeApp"
import EditManageHeader from "../EditManageHeader"

export const EditorialListItemExpanded: React.FC<PostListItemParams> = ({
  post,
  isPostPage = false,
}) => {
  const metaClass = isPostPage ? "col-span-12 pt-2" : PostListItemExpandedStyles.metaDiv
  const commentsClass = isPostPage ? "col-span-12 pt-4" : PostListItemExpandedStyles.commentsDiv
  const [showEditForm, setShowEditForm] = useState(false)
  const { user } = useContext(UserContext)
  const isOwner = user && user.band && user.band.id === post.band_id
  const alteredContent = post.editorial_content.replace(
    /&lt;iframe.*?src="https:\/\/www\.youtube\.com\/embed\/([^"]+)".*?&gt;&lt;\/iframe&gt;/g,
    (match, videoId) => {
      // Replace the escaped iframe with the actual embed HTML
      return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allowfullscreen></iframe>`
    },
  )

  return (
    <div className="grid grid-cols-12">
      <PremiereHeader post={post} size="large" />
      <div className={PostListItemExpandedStyles.contentDiv}>
        <>
          {post.cover_image_url_large ? (
            <img
              src={post.cover_image_url_large}
              alt={post.title}
              className={clsx(styles.editorialHeaderImageExpanded, "w-full")}
            />
          ) : (
            <TextAsImage text={post.title} />
          )}
        </>
      </div>
      <div className={metaClass}>
        <EditManageHeader
          isOwner={isOwner}
          post={post}
          setShowEditForm={setShowEditForm}
        />
        <div className="flex items-start justify-between">
          <h2
            className={clsx(
              PostListItemExpandedStyles.header,
              post.title.length > 100
                ? PostListItemExpandedStyles.headerLong
                : PostListItemExpandedStyles.headerShort,
              "pr-2",
              post.is_bn_premiere && styles.premiereTitle,
            )}
          >
            {post.title}
          </h2>
          <ShareUrlButton nadaUrl={post.nada_url} renderMode="button" />
        </div>
        <div className={styles.subtitle}>{post.subtitle}</div>
        <Link
          className={PostListItemExpandedStyles.bandName}
          to={post.local_path}
        >
          {post.band_name}
        </Link>
        <h3 className={PostListItemExpandedStyles.postDate}>
          {SmartDateFormat({
            dateStr: post.published_at,
            includeTime: false,
          })}
        </h3>
        <div
          className={styles.editorialContent}
          dangerouslySetInnerHTML={{ __html: alteredContent }}
        ></div>
      </div>
      <div className={commentsClass}>
        <RelatedPosts postId={post.id} className="mb-4" />
        <ReactionBlock
          contentType="Post"
          contentId={post.id}
          postId={post.id}
        />
        <CommentSection
          postId={post.id}
          headerText="The Peanut Gallery Says:"
          className="my-4"
        />
      </div>
    </div>
  )
}
